module.exports = __webpack_public_path__ + "fonts/AdelleSAGE.7f3ea31a.woff";